import { calendarSelected, userSelectedCalendar } from '../actions/calendarActions';
import { unauthorizedCalendarProviderCalendarSelected } from '../actions/publicActions';
import getCalendarLoadingState from '../selectors/getCalendarLoadingState';
import { isLocalLieCalendar } from 'owa-calendar-surface-calendars-store';
import { orchestrator } from 'satcheljs';

orchestrator(userSelectedCalendar, actionMessage => {
    const { calendar } = actionMessage;

    if (isLocalLieCalendar(calendar)) {
        // If its a local lie then no-op
        return;
    } else if (getCalendarLoadingState(calendar) === 'CalendarProviderUnauthorized') {
        unauthorizedCalendarProviderCalendarSelected(calendar);
    } else {
        calendarSelected(calendar);
    }
});
